export default __webpack_public_path__ + "static/logo-43fce68c43bb6bd5c05248f5d192e83f.png";